<div class="my-5">
  <!-- page-header -->
  <sm-page-header [breadcrumb]="breadcrumb" title="paa.pages.full_history"> </sm-page-header>
  <!-- content -->
  <div class="content">
    <sm-data-table-builder [dataTableObject]="datatableObject" [datas]="data" [totalRecords]="totalRecords" [loading]="loading">
    </sm-data-table-builder>
  </div>
</div>
